/**
 * 站点监测模块第 2 组（src/views/websiteMonitoring/modules，第 21 个文件起）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '确定': 'OK',
  '关闭': 'Close',
  '查询': 'Query',
  '详情': 'Details',
  '操作': 'Action',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '更新时间': 'Updated At',
  '状态': 'Status',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',
  '正常': 'Normal',
  '异常': 'Abnormal',
  '未知': 'Unknown',
  '离线': 'Offline',
  '请输入': 'Please enter',
  '操作成功': 'Operation successful',

  // ── 弹窗标题 / 页签 / 区块 ──
  '命令队列': 'Command Queue',
  '命令下发': 'Send Command',
  '编辑标准': 'Edit Standard',
  '手动录入': 'Manual Entry',
  '压力曲线图': 'Pressure Curve',
  '温度曲线图': 'Temperature Curve',
  '液位曲线图': 'Liquid Level Curve',
  '水质曲线图': 'Water Quality Curve',
  '数据图形展示': 'Data Chart',
  '数据列表': 'Data List',
  '数据详情': 'Data Details',
  '基本数据': 'Basic Data',
  '水质指标': 'Water Quality Indicators',
  '基本信息': 'Basic Information',
  '历史数据': 'Historical Data',
  '图形展示': 'Charts',
  '今日': 'Today',
  '近三天': 'Last 3 Days',
  '近一周': 'Last 7 Days',

  // ── 设备 / 通信详情词条 ──
  '设备': 'Device',
  '设备ID': 'Device ID',
  '设备编号': 'Device No.',
  '设备名称': 'Device Name',
  '设备类型': 'Device Type',
  '设备安装地址': 'Device Installation Address',
  '安装位置': 'Installation Location',
  '安装经度': 'Installation Longitude',
  '安装纬度': 'Installation Latitude',
  '平台类型': 'Platform Type',
  '描述': 'Description',
  'SIM卡号': 'SIM Card No.',
  'IMEI号': 'IMEI No.',
  '上传时间': 'Upload Time',
  '表端时间': 'Meter Time',
  '表类型': 'Meter Type',
  '表编号': 'Meter No.',
  '仪表类型': 'Instrument Type',
  '仪表电池电压(%)': 'Instrument Battery Voltage (%)',
  'GPRS电池电压(%)': 'GPRS Battery Voltage (%)',
  '软件版本号': 'Software Version',
  '硬件版本号': 'Hardware Version',
  '信号值': 'Signal Value',
  'CSQ(信号指示)': 'CSQ (Signal Indicator)',
  'RSRP(信号强度)': 'RSRP (Signal Strength)',
  'RSRQ(信号质量)': 'RSRQ (Signal Quality)',
  'SNR(信噪比)': 'SNR (Signal-to-Noise Ratio)',
  '上报时间': 'Report Time',
  '上报方式': 'Report Method',
  '上报时间(分钟)': 'Report Interval (min)',
  '上传时间(分钟)': 'Upload Interval (min)',
  '采样时间': 'Sampling Interval',
  '采样时间(秒)': 'Sampling Interval (s)',
  '采样时间(*10秒)': 'Sampling Interval (*10s)',

  // ── 压力 / 液位 / 温度 ──
  '压力值(MPa)': 'Pressure (MPa)',
  '液位值(m)': 'Liquid Level (m)',
  '压力值/液位值': 'Pressure/Liquid Level',
  '温度(℃)': 'Temperature (℃)',
  '温度值(℃)': 'Temperature (℃)',
  '温度值': 'Temperature',
  '电压值(V)': 'Voltage (V)',
  '电压值(%)': 'Voltage (%)',
  '电压(V)': 'Voltage (V)',
  '总流量(m³)': 'Total Flow (m³)',
  '正向流量(m³)': 'Forward Flow (m³)',
  '反向流量(m³)': 'Reverse Flow (m³)',
  '瞬时流量(m³)': 'Instantaneous Flow (m³)',
  '流速(m³/h)': 'Flow Rate (m³/h)',
  '总累计流量(m³)': 'Total Cumulative Flow (m³)',
  '电量 %': 'Battery %',
  '电池状态': 'Battery Status',
  '欠压': 'Undervoltage',
  '传感器状态': 'Sensor Status',
  '告警状态': 'Alarm Status',
  '告警上限': 'Alarm Upper Limit',
  '告警下限': 'Alarm Lower Limit',
  '上限值': 'Upper Limit',
  '下限值': 'Lower Limit',
  '上限：': 'Upper Limit: ',
  '下限：': 'Lower Limit: ',

  // ── 阀门 ──
  '阀门状态': 'Valve Status',
  '阀门开度': 'Valve Opening',
  '阀门角度': 'Valve Angle',
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',

  // ── 命令下发 / 命令队列 ──
  '命令类型': 'Command Type',
  '命令状态': 'Command Status',
  '命令标识': 'Command ID',
  '命令参数': 'Command Parameters',
  '命令内容': 'Command Content',
  '命令回应': 'Command Response',
  '命令回应内容': 'Command Response',
  '发送状态': 'Send Status',
  '发送时间': 'Send Time',
  '回应时间': 'Response Time',
  '接收回应时间': 'Response Received At',
  '选择命令': 'Select Command',
  '读命令': 'Read Commands',
  '写命令': 'Write Commands',
  '加入队列': 'Add to Queue',
  '读采集器NB网络参数': 'Read Collector NB Network Parameters',
  '读取采集间隔': 'Read Collection Interval',
  '读取自动上传时间点': 'Read Auto Upload Time Points',
  '读取采集器NB网络参数': 'Read Collector NB Network Parameters',
  '读取上传间隔': 'Read Upload Interval',
  '写采集器NB网络参数': 'Write Collector NB Network Parameters',
  '设置采集器NB网络参数': 'Set Collector NB Network Parameters',
  '设置采集间隔': 'Set Collection Interval',
  '设置自动上传时间': 'Set Auto Upload Time',
  '设置自动上传时间点': 'Set Auto Upload Time Points',
  '设置上传间隔': 'Set Upload Interval',
  '设置采集器阀门控制': 'Set Collector Valve Control',
  '阀门角度校正': 'Valve Angle Calibration',
  '设置阀门角度': 'Set Valve Angle',
  '终端参数设置': 'Terminal Parameter Settings',
  '终端参数配置': 'Terminal Parameter Configuration',
  '设置压力/液位报警参数': 'Set Pressure/Liquid Level Alarm Parameters',
  '设置温度报警': 'Set Temperature Alarm',
  '设置上报参数': 'Set Report Parameters',
  '电池电量是否复位': 'Reset Battery Level',
  '压力报警上限': 'Pressure Alarm Upper Limit',
  '压力报警下限': 'Pressure Alarm Lower Limit',
  '压力波动报警值': 'Pressure Fluctuation Alarm Value',
  '压力恢复报警差值': 'Pressure Recovery Alarm Difference',
  '液位报警上限': 'Liquid Level Alarm Upper Limit',
  '液位报警下限': 'Liquid Level Alarm Lower Limit',
  '液位波动报警值': 'Liquid Level Fluctuation Alarm Value',
  '液位恢复报警差值': 'Liquid Level Recovery Alarm Difference',
  '温度报警上限': 'Temperature Alarm Upper Limit',
  '温度报警下限': 'Temperature Alarm Lower Limit',
  '温度波动报警值': 'Temperature Fluctuation Alarm Value',
  '温度恢复报警差值': 'Temperature Recovery Alarm Difference',
  '压力报警上限(MPa)': 'Pressure Alarm Upper Limit (MPa)',
  '压力报警下限(MPa)': 'Pressure Alarm Lower Limit (MPa)',
  '压力波动报警值(MPa)': 'Pressure Fluctuation Alarm Value (MPa)',
  '压力恢复报警差值(MPa)': 'Pressure Recovery Alarm Difference (MPa)',
  '压力恢复报警值(MPa)': 'Pressure Recovery Alarm Value (MPa)',
  '液位报警上限(m)': 'Liquid Level Alarm Upper Limit (m)',
  '液位报警下限(m)': 'Liquid Level Alarm Lower Limit (m)',
  '液位波动报警值(m)': 'Liquid Level Fluctuation Alarm Value (m)',
  '液位恢复报警值(m)': 'Liquid Level Recovery Alarm Value (m)',
  '液位恢复报警差值(m)': 'Liquid Level Recovery Alarm Difference (m)',
  '温度波动报警值(℃)': 'Temperature Fluctuation Alarm Value (℃)',
  '温度恢复报警值(℃)': 'Temperature Recovery Alarm Value (℃)',
  '温度报警上限(℃)': 'Temperature Alarm Upper Limit (℃)',
  '温度报警下限(℃)': 'Temperature Alarm Lower Limit (℃)',
  '温度恢复报警差值(℃)': 'Temperature Recovery Alarm Difference (℃)',
  '电池电量复位': 'Battery Level Reset',
  'IP地址': 'IP Address',
  '端口号': 'Port',
  '采集间隔(分钟)': 'Collection Interval (min)',
  '分钟': 'min',

  // ── 0-23 点分钟值（设置自动上传时间）──
  '0点分钟值': 'Minute Value at 0:00',
  '1点分钟值': 'Minute Value at 1:00',
  '2点分钟值': 'Minute Value at 2:00',
  '3点分钟值': 'Minute Value at 3:00',
  '4点分钟值': 'Minute Value at 4:00',
  '5点分钟值': 'Minute Value at 5:00',
  '6点分钟值': 'Minute Value at 6:00',
  '7点分钟值': 'Minute Value at 7:00',
  '8点分钟值': 'Minute Value at 8:00',
  '9点分钟值': 'Minute Value at 9:00',
  '10点分钟值': 'Minute Value at 10:00',
  '11点分钟值': 'Minute Value at 11:00',
  '12点分钟值': 'Minute Value at 12:00',
  '13点分钟值': 'Minute Value at 13:00',
  '14点分钟值': 'Minute Value at 14:00',
  '15点分钟值': 'Minute Value at 15:00',
  '16点分钟值': 'Minute Value at 16:00',
  '17点分钟值': 'Minute Value at 17:00',
  '18点分钟值': 'Minute Value at 18:00',
  '19点分钟值': 'Minute Value at 19:00',
  '20点分钟值': 'Minute Value at 20:00',
  '21点分钟值': 'Minute Value at 21:00',
  '22点分钟值': 'Minute Value at 22:00',
  '23点分钟值': 'Minute Value at 23:00',

  // ── 取水井 / 泵（井电控制）──
  '终端号': 'Terminal No.',
  '计量方式(m³/h)': 'Metering Method (m³/h)',
  '取水井名': 'Well Name',
  '井地址': 'Well Address',
  '水利编号': 'Water Conservancy No.',
  '取水证号及电子证号': 'Water Withdrawal Permit No. & E-Permit No.',
  '总用水量(m³)': 'Total Water Use (m³)',
  '剩余水量(m³)': 'Remaining Water (m³)',
  '报警状态': 'Alarm Status',
  '关泵': 'Pump Off',
  '在线抽水中': 'Pumping (Online)',
  '综合保护器报警': 'Comprehensive Protector Alarm',
  '有脉冲干扰': 'Pulse Interference',
  '断线报警': 'Disconnection Alarm',
  '箱门状态': 'Cabinet Door Status',
  '箱门关闭': 'Door Closed',
  '箱门开启': 'Door Open',

  // ── 水质指标 ──
  'PH值': 'pH',
  'PH电极通讯状态': 'pH Electrode Comm Status',
  'PH报警状态': 'pH Alarm Status',
  '色度': 'Chroma',
  '浊度': 'Turbidity',
  '浑浊度(NTU)': 'Turbidity (NTU)',
  '溶解性总固体(mg/L)': 'Total Dissolved Solids (mg/L)',
  '硬度': 'Hardness',
  '硬度(mg/L)': 'Hardness (mg/L)',
  '氧化还原': 'ORP',
  'ORP(mv)': 'ORP (mV)',
  '氯化物': 'Chloride',
  '氯化物(mg/L)': 'Chloride (mg/L)',
  '余氯': 'Residual Chlorine',
  '余氯(mg/L)': 'Residual Chlorine (mg/L)',
  '硫酸盐(mg/L)': 'Sulfate (mg/L)',
  '电导率': 'Conductivity',
  '电导率(μS/cm)': 'Conductivity (μS/cm)',
  '酸碱度': 'pH',
  '浊度电极通讯状态': 'Turbidity Electrode Comm Status',
  '氯化物电极通讯状态': 'Chloride Electrode Comm Status',
  '余氯电极通讯状态': 'Residual Chlorine Electrode Comm Status',
  '电导率电极通讯状态': 'Conductivity Electrode Comm Status',
  '浊度报警状态': 'Turbidity Alarm Status',
  '氯化物报警状态': 'Chloride Alarm Status',
  '余氯报警状态': 'Residual Chlorine Alarm Status',
  '电导率报警状态': 'Conductivity Alarm Status',
  '缺水状态': 'Water Shortage Status',
  '缺水': 'Water Shortage',
  '高报': 'High Alarm',
  '低报': 'Low Alarm',

  // ── 校验标准录入 ──
  '请输入温度值上限': 'Please enter temperature upper limit',
  '请输入温度值下限': 'Please enter temperature lower limit',
  '请输入PH值上限': 'Please enter pH upper limit',
  '请输入PH值下限': 'Please enter pH lower limit',
  '请输入色度上限': 'Please enter chroma upper limit',
  '请输入色度下限': 'Please enter chroma lower limit',
  '请输入浑浊度上限': 'Please enter turbidity upper limit',
  '请输入浑浊度下限': 'Please enter turbidity lower limit',
  '请输入溶解性总固体上限': 'Please enter total dissolved solids upper limit',
  '请输入溶解性总固体下限': 'Please enter total dissolved solids lower limit',
  '请输入硬度上限': 'Please enter hardness upper limit',
  '请输入硬度下限': 'Please enter hardness lower limit',
  '请输入ORP上限': 'Please enter ORP upper limit',
  '请输入ORP下限': 'Please enter ORP lower limit',
  '请输入氯化物上限': 'Please enter chloride upper limit',
  '请输入氯化物下限': 'Please enter chloride lower limit',
  '请输入余氯上限': 'Please enter residual chlorine upper limit',
  '请输入余氯下限': 'Please enter residual chlorine lower limit',
  '请输入硫酸盐上限': 'Please enter sulfate upper limit',
  '请输入硫酸盐下限': 'Please enter sulfate lower limit',
  '请输入电导率上限': 'Please enter conductivity upper limit',
  '请输入电导率下限': 'Please enter conductivity lower limit',
  '请输入备注': 'Please enter remark',

  // ── 表单校验 / 消息提示 ──
  '该设备ID已存在，请重新输入!': 'This device ID already exists, please re-enter!',
  '请输入设备ID': 'Please enter device ID',
  '请输入设备名称': 'Please enter device name',
  '请输入设备安装位置': 'Please enter device installation location',
  '请选择设备类型': 'Please select device type',
  '请选择平台类型': 'Please select platform type',
  '请输入SIM卡号': 'Please enter SIM No.',
  '请输入安装经度': 'Please enter installation longitude',
  '请输入水表安装纬度': 'Please enter meter installation latitude',
  '请输入设备名称搜索': 'Search by device name',
  '请选择设备': 'Please select device',
  '选择上报时间': 'Select report time',
  '请选择上报时间': 'Please select report time',
  '请至少录入一项指标值': 'Please enter at least one indicator value',
  '录入成功': 'Entry saved',
  '录入失败': 'Entry failed',
  '请输入命令参数': 'Enter command parameters',
  '请先选择命令': 'Please select a command first',
  '请设置参数': 'Please set parameters',
  '命令添加成功': 'Command added successfully',
  '请输入阀门角度!': 'Please enter valve angle!',
  '请输入阀门角度': 'Please enter valve angle',
  '请输入采集间隔!': 'Please enter collection interval!',
  '请输入采集间隔': 'Please enter collection interval',
  '请选择阀门状态!': 'Please select valve status!',
  '请输入分钟值': 'Please enter minute value',
  'IP输入有误': 'Invalid IP address',
  '端口号输入有误': 'Invalid port number',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',

  // ── 告警状态映射（数据字典值）──
  'NB压力表': 'NB Pressure Gauge',
  'NB液位计': 'NB Liquid Level Gauge',
  '4G压力表': '4G Pressure Gauge',
  '4G液位计': '4G Liquid Level Gauge',
  '液位下限报警': 'Liquid Level Lower Limit Alarm',
  '液位上限报警': 'Liquid Level Upper Limit Alarm',
  '温度下限报警': 'Temperature Lower Limit Alarm',
  '温度上限报警': 'Temperature Upper Limit Alarm',
  '液位下限报警、温度下限报警': 'Liquid Level Lower Limit Alarm, Temperature Lower Limit Alarm',
  '液位下限报警、温度上限报警': 'Liquid Level Lower Limit Alarm, Temperature Upper Limit Alarm',
  '液位上限报警 温度下限报警': 'Liquid Level Upper Limit Alarm, Temperature Lower Limit Alarm',
  '液位上限报警 温度上限报警': 'Liquid Level Upper Limit Alarm, Temperature Upper Limit Alarm',
  '压力下限报警': 'Pressure Lower Limit Alarm',
  '压力上限报警': 'Pressure Upper Limit Alarm',
  '压力下限报警、温度下限报警': 'Pressure Lower Limit Alarm, Temperature Lower Limit Alarm',
  '压力下限报警、温度上限报警': 'Pressure Lower Limit Alarm, Temperature Upper Limit Alarm',
  '压力上限报警 温度下限报警': 'Pressure Upper Limit Alarm, Temperature Lower Limit Alarm',
  '压力上限报警 温度上限报警': 'Pressure Upper Limit Alarm, Temperature Upper Limit Alarm',
  '电池电量报警': 'Battery Level Alarm',

  // ── 上报方式映射（protocolConstant.tuopuruiSendWayObj 值）──
  '定时上报': 'Scheduled Report',
  '上电上报': 'Power-on Report',
  '手动上报': 'Manual Report',
  '故障上报': 'Fault Report',
  '事件上报': 'Event Report',

  // ── 通讯状态映射（protocolConstant.reportStatusObj 值）──
  '未发送': 'Not Sent',
  '正在下发': 'Dispatching',
  '已下达': 'Issued',
  '执行成功': 'Executed Successfully',
  '已取消': 'Cancelled',
  '执行失败': 'Execution Failed',
  '过期未执行': 'Expired, Not Executed',

  // ── 命令类型映射（protocolConstant.dataFlagObj 值）──
  '读取表具信息': 'Read Meter Info',
  '剩余金额更新': 'Remaining Balance Update',
  '校时': 'Time Sync',
  '写表号': 'Write Meter No.',
  '读表号': 'Read Meter No.',
  '阀控操作': 'Valve Control Operation',
  '强制开阀': 'Force Open Valve',
  '强制关阀': 'Force Close Valve',
  '取消强制': 'Cancel Force',
  '修改运行密匙': 'Modify Operating Key',
  '配置表上报参数': 'Configure Meter Report Parameters',
  '读取表上报参数': 'Read Meter Report Parameters',
  '配置表网络参数': 'Configure Meter Network Parameters',
  '读取表网络参数': 'Read Meter Network Parameters',
  '配置表工作参数': 'Configure Meter Working Parameters',
  '读取表工作参数': 'Read Meter Working Parameters',
  '读取表历史数据': 'Read Meter History Data',
  '读取模组IMEI号': 'Read Module IMEI',
  '读取模组版本号': 'Read Module Version',
  '读取模组状态': 'Read Module Status',
  '读取SIM卡号': 'Read SIM Card No.',
  '表端自检功能': 'Meter Self-Check',
  '读取最近10次阀门动作原因': 'Read Last 10 Valve Action Reasons',
  '清除表端故障': 'Clear Meter Faults',
  '模块初始化配置': 'Module Initialization Config',
  '读取程序版本信息': 'Read Program Version Info',
  '读取最近10次联网失败原因': 'Read Last 10 Network Failure Reasons',
  '读取最近10次表端故障原因': 'Read Last 10 Meter Fault Reasons',
  '读取表端最近10次磁干扰故障': 'Read Last 10 Magnetic Interference Faults',
  '读SIM卡ismi号': 'Read SIM IMSI No.',
  '查询终端参数': 'Query Terminal Parameters',
  '查询基础信息': 'Query Basic Info',
  '历史日结信息查询': 'Daily Settlement History Query',
  '阀门动作记录查询': 'Valve Action Record Query',
  '联网失败记录': 'Network Failure Records',
  '终端故障记录': 'Terminal Fault Records',
  '查询实时数据': 'Query Real-time Data',
  '取消阀控': 'Cancel Valve Control',
  '修改运行秘钥': 'Modify Operating Key',
  '修改根秘钥': 'Modify Root Key',

  // ── 曲线图标注 ──
  '压力': 'Pressure',
  '温度': 'Temperature',
  '液位': 'Liquid Level',
  '低位告警线': 'Low Alarm Line',
  '高位告警线': 'High Alarm Line',
  '液位报警上限(℃)': 'Liquid Level Alarm Upper Limit (℃)',
  '液位报警下限(℃)': 'Liquid Level Alarm Lower Limit (℃)',
}
